import { Ok, Err } from "../result/Result";
export class Some {
    constructor(v) {
        this.value = v;
    }
    static wrapNull(value) {
        if (value == null) {
            return None.instance();
        }
        if (value !== null && typeof value === "object") {
            return new Some(value);
        }
        return None.instance();
    }
    map(fn) {
        return Maybe(fn(this.value));
    }
    isSome() {
        return true;
    }
    isNone() {
        return false;
    }
    isSomeAnd(fn) {
        return fn(this.value);
    }
    isNoneAnd(fn) {
        return false;
    }
    unwrap() {
        return this.value;
    }
    unwrapOr(def) {
        return this.value;
    }
    unwrapOrElse(f) {
        return this.value;
    }
    flatmap(f) {
        return f(this.value);
    }
    mapOr(def, f) {
        return f(this.value);
    }
    mapOrElse(def, f) {
        return f(this.value);
    }
    okOr(err) {
        return new Ok(this.value);
    }
    okOrElse(err) {
        return new Ok(this.value);
    }
    and(optb) {
        return optb;
    }
    andThen(f) {
        return f(this.value);
    }
    or(optb) {
        return this;
    }
    orElse(f) {
        return this;
    }
    toString() {
        return "Some " + this.value;
    }
    filter(f) {
        if (f(this.value))
            return this;
        return None.instance();
    }
}
export class None {
    constructor() {
    }
    map(fn) {
        return None._instance;
    }
    isSome() {
        return false;
    }
    isNone() {
        return true;
    }
    isSomeAnd(fn) {
        return false;
    }
    isNoneAnd(fn) {
        return fn();
    }
    unwrap() {
        console.error("None.unwrap()");
        throw "None.get";
    }
    unwrapOr(def) {
        return def;
    }
    unwrapOrElse(f) {
        return f();
    }
    flatmap(f) {
        return None.instance();
    }
    mapOr(def, f) {
        return def;
    }
    mapOrElse(def, f) {
        return def();
    }
    okOr(err) {
        return new Err(err);
    }
    okOrElse(err) {
        return new Err(err());
    }
    and(optb) {
        return None.instance();
    }
    andThen(f) {
        return None.instance();
    }
    or(optb) {
        return optb;
    }
    orElse(f) {
        return f();
    }
    static instance() {
        return None._instance;
    }
    toString() {
        return "None";
    }
    filter(f) {
        return this;
    }
}
None._instance = new None();
export function Maybe(v) {
    if (v === null || typeof v === 'undefined')
        return None.instance();
    return new Some(v);
}
